var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 140,
    viewBox: "0 0 196 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.333 123C172.317 123 179.585 115.65 179.585 106.667L179.667 16.8333C179.667 7.85 172.317 0.5 163.333 0.5H32.6667C23.6833 0.5 16.3333 7.85 16.3333 16.8333V106.667C16.3333 115.65 23.6833 123 32.6667 123H0C0 131.983 7.35 139.333 16.3333 139.333H179.667C188.65 139.333 196 131.983 196 123H163.333ZM32.6667 16.8333H163.333V106.667H32.6667V16.8333ZM98 131.167C93.5083 131.167 89.8333 127.492 89.8333 123C89.8333 118.508 93.5083 114.833 98 114.833C102.492 114.833 106.167 118.508 106.167 123C106.167 127.492 102.492 131.167 98 131.167Z",
    fill: "#F2CC8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.38e5a3efc5bc482b60f74416ed27191b.svg";
export { ForwardRef as ReactComponent };